import AOS from "aos";
import "slick-carousel";
import { footerClass } from "./components/footer";
import { euComplianceBanner } from "./components/euComplianceBanner";
import { initConsultance } from "./components/consultance";
import { languageSwitcher } from "./components/languageSwitcher";
import "aos/dist/aos.css";
import Rellax from "rellax";
import "./components/slickWhatWeOffer";
import "./components/popupVideo";

global.$ = jQuery;

$(function () {
  // footerClass();

  initConsultance();
  languageSwitcher();

  // if ($('div.blue').length) {
  //     $("span.blue-text").hide();
  // }

  // if ($('div.pink').length) {
  //     $("span.orange-text").hide();
  // }
  // if ($('div.orange').length) {
  //     $("span.green-text").hide();
  // }
  // if ($('div.pink-text').length) {
  //     $("span.green").hide();
  // }
  // if ($('div.pink-text').length) {
  //     $("span.green").hide();
  // }
  // if($('div.light-green').lenght) {
  //     $("span.light-green-text")
  // }

  const bluePage = $("div.blue");
  const orangePage = $("div.orange");
  const greenPage = $("div.green");
  const lighGreenPage = $("div.light-green");
  const pinkPage = $("div.pink");
  const redPage = $(".page-node-type-who-we-are");
  const contact = $(".page-node-type-contact");

  if (bluePage.length) {
    $(".layout-container").addClass("blue-banner");
  }
  if (orangePage.length) {
    $(".layout-container").addClass("orange-banner");
  }
  if (greenPage.length) {
    $(".layout-container").addClass("green-banner");
  }
  if (redPage.length) {
    $(".layout-container").addClass("red-banner");
  }
  if (pinkPage.length) {
    $(".layout-container").addClass("pink-banner");
  }
  if (lighGreenPage.length) {
    $(".layout-container").addClass("light-green-banner");
  }
  if (contact.length) {
    $(".layout-container").addClass("red-banner");
  }

  if ($(".node__content .blue").length) {
    $("#block-consultancecontactez").show();
    $("#block-ecriturecontactez-2").hide();
    $("#block-relecturecontactez").hide();
    $("#block-traductioncontactez").hide();
    $("#block-prisedeparolecontactez").hide();
    $("#block-consultancecontactezbottom").show();
    $("#block-ecriturecontactezbottom").hide();
    $("#block-relecturecontactezbottom").hide();
    $("#block-traductioncontactezbottom").hide();
    $("#block-prisedeparolecontactezbottom").hide();
  }
  if ($(".node__content .orange").length) {
    $("#block-consultancecontactez").hide();
    $("#block-ecriturecontactez-2").show();
    $("#block-relecturecontactez").hide();
    $("#block-traductioncontactez").hide();
    $("#block-prisedeparolecontactez").hide();
    $("#block-consultancecontactezbottom").hide();
    $("#block-ecriturecontactezbottom").show();
    $("#block-relecturecontactezbottom").hide();
    $("#block-traductioncontactezbottom").hide();
    $("#block-prisedeparolecontactezbottom").hide();
  }
  if ($(".node__content .green").length) {
    $("#block-consultancecontactez").hide();
    $("#block-ecriturecontactez-2").hide();
    $("#block-relecturecontactez").show();
    $("#block-traductioncontactez").hide();
    $("#block-prisedeparolecontactez").hide();
    $("#block-consultancecontactezbottom").hide();
    $("#block-ecriturecontactezbottom").hide();
    $("#block-relecturecontactezbottom").show();
    $("#block-traductioncontactezbottom").hide();
    $("#block-prisedeparolecontactezbottom").hide();
  }
  if ($(".node__content .pink").length) {
    $("#block-consultancecontactez").hide();
    $("#block-ecriturecontactez-2").hide();
    $("#block-relecturecontactez").hide();
    $("#block-traductioncontactez").show();
    $("#block-prisedeparolecontactez").hide();
    $("#block-consultancecontactezbottom").hide();
    $("#block-ecriturecontactezbottom").hide();
    $("#block-relecturecontactezbottom").hide();
    $("#block-traductioncontactezbottom").show();
    $("#block-prisedeparolecontactezbottom").hide();
  }
  if ($(".node__content .light-green").length) {
    $("#block-consultancecontactez").hide();
    $("#block-ecriturecontactez-2").hide();
    $("#block-relecturecontactez").hide();
    $("#block-traductioncontactez").hide();
    $("#block-prisedeparolecontactez").show();
    $("#block-consultancecontactezbottom").hide();
    $("#block-ecriturecontactezbottom").hide();
    $("#block-relecturecontactezbottom").hide();
    $("#block-traductioncontactezbottom").hide();
    $("#block-prisedeparolecontactezbottom").show();
  }

  euComplianceBanner();
  const index = 1;

  $(".intro a").on("click", (target) => {
    target.preventDefault();
    document.getElementById("main-anchor").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    //$(".card-button").addClass("cssanimation sequence fadeInBottom");
    //$(".intro-title").addClass("cssanimation sequence fadeInBottom");
    $(".homepage-intro").addClass("hidden-out");
    $(".homepage").addClass("show");
    // $('.homepage .home img').addClass('cssanimation2 fadeInTop');
    $(".home-links").addClass("opacity-animation");
    // $('.logo-text').addClass('cssanimation sequence fadeInBottom')
    $(".feather-image").addClass("feather-animation-active");
    $(".logo-text").addClass("logo-animation fadeInBottom");
  });

  if ($(".node__content").find(".light-green").length > 0) {
    $(".service").addClass("show");
  }
  $(".who-we-are-wrapper-percent h2").attr("data-aos", "fade-up");
  $(".who-we-are-wrapper-percent p").attr("data-aos", "fade-up");
  $(".who-we-are-wrapper-percent h5").attr("data-aos", "fade-up");
  $(".who-we-are-wrapper-percent h4").attr("data-aos", "fade-right");
  $(".name-of-client h2").attr("data-aos", "no-animation");
  $(".name-of-client h3").attr("data-aos", "fade-right");
  $(".name-of-client p").attr("data-aos", "fade-right");
  $(".name-of-client .name-of-client-right-content p").attr(
    "data-aos",
    "fade-left"
  );
  $(".name-of-client .name-of-client-right-content h3").attr(
    "data-aos",
    "fade-left"
  );
  $(".name-of-client .text-formatted p").attr("data-aos", "no-animation");
  $(".partners-content-body .field__item").attr("data-aos", "fade-right");
  $(".partners-content-slider .field--type-image").attr("data-aos", "fade-up");
  $(".partners-content-slider .field--name-field-partner-list-label").attr(
    "data-aos",
    "fade-left"
  );

  $(document).ready(function () {
    const hashcode = window.location.hash;
    const anchor = hashcode.indexOf("#");
    if (anchor > -1) {
      const dom_id = hashcode.substring(anchor + 1);
      const is_exist = $("#" + dom_id).length;
      if (is_exist) {
        if (jQuery(".popup-menu").is(":hidden") == false) {
          $(".popup-menu__close").trigger("click");
        }
        if ($(".homepage").length) {
          if ($(".homepage").hasClass("show") == false) {
            $("#home-link").trigger("click");
          }
        }
        document.getElementById(dom_id).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }

    $("video").on("ended", function () {
      document.getElementById("main-anchor").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });

      $(".feather-image").addClass("feather-animation-active");
      //$(".card-button").addClass("cssanimation sequence fadeInBottom");
      $(".homepage-intro").addClass("hidden-out");
      $(".homepage").addClass("show");
      $(".logo-text").addClass("logo-animation fadeInBottom");
      $(".home-links").addClass("opacity-animation");
    });

    AOS.init({
      delay: 200,
      duration: 800,
      once: true,
      disable: "mobile",
    });
    $(".feather-img").addClass("rellax").attr("data-rellax-speed", "-7");
    const rellax = new Rellax(".rellax", {
      speed: -2,
      center: false,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false,
    });

    $('a[href*="#"]').on("click", function (event) {
      var the_id = $(this).attr("href");
      const anchor = the_id.indexOf("#");
      if (anchor > -1 && the_id !== "#") {
        const dom_id = the_id.substring(anchor);
        const is_exist = $(dom_id).length;
        if (is_exist) {
          if (jQuery(".popup-menu").is(":hidden") == false) {
            $(".popup-menu__close").trigger("click");
          }
          if ($(".homepage").length) {
            if ($(".homepage").hasClass("show") == false) {
              $("#home-link").trigger("click");
            }
          }
          $("html, body").animate(
            {
              scrollTop: $(dom_id).offset().top,
            },
            "slow"
          );
          event.preventDefault();
        }
      }
    });
  });
  $(".consultance-page .body0__section a")
    .addClass("Da")
    .click(function (e) {
      const link = $(this).attr("href");
      if (link == undefined || (link !== undefined && link[0] == "#")) {
        e.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $("#casestudy--section").offset().top,
          },
          800
        );
      }
    });
  $("#edit-joignez-vos-documents-ici-upload-button").val("Ajouter un fichier");
  $("#edit-title option").first().text("");
  // function animatePage(event) {

  //     if (event.originalEvent.deltaY > 0) {

  //         if (index >= 1 && index < pageToAnimate.length) {
  //             $(`.intro`).removeClass("in-transition")
  //             $(`.intro-0${index}`).addClass("in-transition")

  //             index++;

  //             $(".in-transition").animate({
  //                 height: "toggle"
  //             }, 500)
  //         }
  //     } else {

  //         if (index <= pageToAnimate.length && index > 1) {

  //             $(`.intro`).removeClass("in-transition")
  //             index--

  //             $(`.intro-0${index}`).addClass("in-transition")

  //             $(".in-transition").animate({
  //                 height: "toggle"
  //             }, 500)

  //         }
  //     }
  // }
  // $(window).on("wheel", function(event) {

  //     var now = Date.now();
  //     var nt = $(this).data("lastime") || now;
  //     if (nt > now) return;
  //     $(this).data("lastime", now + 850);
  //     animatePage(event)

  // });

  $(".burger-menu").on("click", (e) => {
    e.preventDefault();
    $(".popup-menu").slideDown("slow");
  });

  $(".popup-menu__close").on("click", (e) => {
    e.preventDefault();
    $(".popup-menu").slideUp("slow");
  });

  // $(".tb-megamenu-item.level-1.dropdown").on("click", (e) => {
  //   e.preventDefault();
  //   $(this).toggleClass("active", 1000);
  //   $(this).find(".nav-child").toggleClass("active", 1000);
  // });

  if ($(".btn-fake").length > 0) {
    const btnFake = $(".btn-fake");
    $(".js-webform-document-file").append(btnFake);

    $(document).on("click", ".btn-fake", function () {
      $(".js-form-file").trigger("click");
    });

    $(document).ajaxComplete(function (event, xhr, settings) {
      // Check if the AJAX request is successful.
      if (settings && settings.type === "POST" && xhr.status === 200) {
        // Trigger the custom event.
        $(".js-form-file").after(btnFake);

        if ($(".form-type-checkbox").length == 2) {
          $(".btn-fake").hide();
        }
      }
    });
  }
});
